import { createContext, useContext } from 'react';

interface FloatingButtonGroupContextType {
  setFloatingButtonGroupActiveEl: ((el: HTMLElement) => void) | null;
  floatingGroup: boolean;
  srOnly: boolean;
}

export const FloatingButtonGroupContext =
  createContext<FloatingButtonGroupContextType>({
    setFloatingButtonGroupActiveEl: null,
    floatingGroup: false,
    srOnly: false,
  });

export const { Provider: FloatingButtonGroupContextProvider } =
  FloatingButtonGroupContext;

export const useFloatingButtonGroupContext = () => {
  return useContext(FloatingButtonGroupContext);
};
